"use client"
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRef } from "react";
import { useApp } from "@/context/AppContext";

export default function RecordsGalleryBackground({ image }) {
  const rootRef = useRef(null)
  const imageRef = useRef(null)
  const { ready, getTransitionReady, isRouteChanging, headerHeight } = useApp()

  useGSAP(() => {
    const mm = gsap.matchMedia();

    // await ready;
    // await getTransitionReady();

    mm.add(
      {
        hasMotion: "(prefers-reduced-motion: no-preference)",
        hasNoMotion: "(prefers-reduced-motion: reduce)",
      },
      (context) => {
        const { hasMotion, hasNoMotion } = context.conditions;

        if (isRouteChanging) {
          gsap.set(rootRef.current, {
            opacity: 1
          })  
        }

        if (hasMotion) {
          gsap.to(rootRef.current, {
            opacity: 1,
            duration: 1,
            delay: 0.2
          })

          gsap.fromTo(imageRef.current, {
            y: '0%'
          }, {
            y: '25%',
            scrollTrigger: {
              trigger: rootRef.current,
              start: `top top+=${headerHeight}px`,
              end: 'bottom top',
              scrub: true
            }
          })
        } else if (hasNoMotion) {
          gsap.set(rootRef.current, {
            opacity: 1
          })
        }
      }
    )
    if (!isRouteChanging) {

      // return () => mm.revert();
    }
  }, {dependencies: [ready, isRouteChanging, headerHeight], revertOnUpdate: true})

  return (
    <picture className="absolute top-0 lg:top-[calc(-1*var(--header-height)-56px)] aspect-804/1748 lg:aspect-2880/2280 left-0 w-full h-auto opacity-[0.01]" ref={rootRef}>
      <source media="(min-width: 1024px)" srcSet={image.url.desktop} />
      <source media="(max-width: 1023px)" srcSet={image.url.mobile} />
      <img
        ref={imageRef}
        src={image.url.mobile}
        alt="old school postcard"
        className="w-full h-auto will-change-transform"
      />
    </picture>
  );
}
